var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#52B3A7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0393 36.9383L17 36.9225V44.1538C17 45.0246 17.706 45.7306 18.5769 45.7306C18.9951 45.7306 19.3962 45.5645 19.6919 45.2688L23.3074 41.6532H42.2694C44.882 41.6532 47 39.5352 47 36.9225V22.7306C47 20.118 44.882 18 42.2694 18H21.77C19.1573 18 17.0393 20.118 17.0393 22.7306V36.9383Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9042 32.1916C41.2105 32.1916 42.2695 31.1326 42.2695 29.8263C42.2695 28.5199 41.2105 27.4609 39.9042 27.4609C38.5979 27.4609 37.5389 28.5199 37.5389 29.8263C37.5389 31.1326 38.5979 32.1916 39.9042 32.1916ZM32.0198 32.1916C33.3262 32.1916 34.3851 31.1326 34.3851 29.8263C34.3851 28.5199 33.3262 27.4609 32.0198 27.4609C30.7135 27.4609 29.6545 28.5199 29.6545 29.8263C29.6545 31.1326 30.7135 32.1916 32.0198 32.1916ZM24.1354 32.1916C25.4418 32.1916 26.5008 31.1326 26.5008 29.8263C26.5008 28.5199 25.4418 27.4609 24.1354 27.4609C22.8291 27.4609 21.7701 28.5199 21.7701 29.8263C21.7701 31.1326 22.8291 32.1916 24.1354 32.1916Z",
    fill: "#78C8AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.3cec6bab1c27d1785e9480c556c1f614.svg";
export { ForwardRef as ReactComponent };